import Vue from 'vue'
import { GET_PROBLEMATIQUES } from '../mutation-types.js'

export const getProblematiques = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('problematique')
    .then(
      (response) => {
        dispatch(GET_PROBLEMATIQUES, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/problematiquesActions.js